import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withKeys as _withKeys, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref } from 'vue';

export default /*@__PURE__*/_defineComponent({
  ...{ inheritAttrs: false },
  __name: 'CTextField',
  props: {
    title: {},
    label: {},
    buttonColor: {},
    confirmText: { default: 'Done' },
    minWidth: { default: 300 },
    width: { default: '50%' }
  },
  emits: ["update:modelValue", "confirm", "cancel"],
  setup(__props: any, { emit: __emit }) {




// eslint-disable-next-line @typescript-eslint/no-unused-vars
const props = __props;

// const modelValue = defineModel('modelValue', { type: String, required: true });

const emit = __emit;

const local = ref('');
// watch(modelValue, v => { 
//   if (v !== local.value) {
//     local.value = v; 
//   }
// });

// don't update the model value
// watch(local, v => emit('update:modelValue', v));

function onConfirm() {
  if (!local.value.trim()) return;
  emit('confirm', local.value.trim());
}

return (_ctx: any,_cache: any) => {
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_card = _resolveComponent("v-card")!

  return (_openBlock(), _createBlock(_component_v_card, {
    class: "mx-auto px-3 py-2",
    "min-width": __props.minWidth,
    width: __props.width
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "title", {}, () => [
        _createVNode(_component_v_card_title, null, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(__props.title), 1)
          ]),
          _: 1
        })
      ]),
      _createVNode(_component_v_text_field, _mergeProps({ class: "mb-2 px-2" }, _ctx.$attrs, {
        modelValue: local.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((local).value = $event)),
        label: __props.label,
        "hide-details": "",
        autofocus: "",
        onKeyup: _withKeys(onConfirm, ["enter"])
      }), null, 16, ["modelValue", "label"]),
      _createVNode(_component_v_card_actions, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            variant: "text",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('cancel')))
          }, {
            default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
              _createTextVNode("Cancel", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_v_btn, {
            color: __props.buttonColor,
            variant: "flat",
            disabled: !local.value.trim(),
            onClick: onConfirm
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(__props.confirmText), 1)
            ]),
            _: 1
          }, 8, ["color", "disabled"])
        ]),
        _: 1
      })
    ]),
    _: 3
  }, 8, ["min-width", "width"]))
}
}

})